
























import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

@Component
export default class Paginator extends Vue {
    @Prop() readonly totalCount!: number;
    @Prop() perPage!: number;
    @Prop() currentPage!: number;

    perPageList = [10, 20, 50, 100];

    lCurrentPage: number = this.currentPage;
    lPerPage: number = this.perPage;

    @Watch('lCurrentPage')
    @Watch('totalCount')
    onChanged() {
        this.update();
    }

    @Watch('lPerPage')
    onPerPageChanged() {
        this.lCurrentPage = 1;
        this.$nextTick(() => {
            this.update();
        });
    }

    @Watch('currentPage')
    @Watch('perPage')
    onPropertyChanged() {
        this.lCurrentPage = this.currentPage;
        this.lPerPage = this.perPage;
    }

    @Emit('update')
    update() {
        let current = 1;
        if (this.lCurrentPage > Math.ceil(this.totalCount / this.lPerPage) && this.totalCount > 0) {
            current = Math.ceil(this.totalCount / this.lPerPage);
        } else {
            current = this.lCurrentPage;
        }
        return {
            perPage: this.lPerPage,
            currentPage: current,
        };
    }
}
